// API Configuration
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// WebSocket URL - use the same backend URL but with ws/wss protocol
export const WS_URL = (() => {
  const url = new URL(BACKEND_URL);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  return url.origin + '/api/ws/markets';
})();

// Chart colors for recharts
export const CHART_COLORS = ['#10b981', '#3b82f6', '#8b5cf6', '#f59e0b', '#ef4444', '#06b6d4', '#ec4899', '#84cc16'];

// Notification sound (base64 encoded)
export const notificationSound = typeof Audio !== 'undefined' ? new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2teleQYAOY3N5K19FQA8l9LjqXUUAC6Gz96gdxYALIPK2pt2GAAsgcfXl3UaAC5/w9OTcxwAMH7A0I9xHQAxfL3NjG8fADJ5usuIbSAAM3a3yIVqIgA0c7TFgmgjADRwscJ/ZiQANW2uwXxjJQA2aqq+eWEmADZnprp2XicAN2SjuHNbKAA4YJ+0cFgpADlcm7FtVSoAOliXrmpSKwA7VJOqZ08sADtQj6dkTCwAPEuLo2FJLQA9R4afXkYuAD1CgptbQy8APj59l1hAMAA/OXmTVTwxAD8zdI9SNjMAQC5wi08zNABBKWuHTC81AEIkZoNJKzYAQx9hf0YnNwBDGlx7QyM4AEQVWHdAHzkARRBTcz0bOgBFC05vOhc7AEYISmw3EzwARgRFaDQPPQBHAEFlMQs+AEf9O2IuBz8ASPlHXysEQABI9kJcKABBAEjyPVklAEIASe44VyIAQwBJ6zNUIQBEAEnnLlEfAEUASeMpThwARgBJ3yRLGQBHAEnbH0gWAEgASdcaRRMASQBJ0xVCEABKAEnPEEAMAEsAScsKPQkATABJxwU6BgBNAEnDA TcDAE4AScAANAAATwBJvAAxAABQAEm4AC4AAFEASbUAKwAAUgBJsQAoAABTAEmuACUAAFQASaoAIgAAVQBJpwAfAABWAEmlAB0AAFcASaIAGgAAWABJoAAYAABZAEmeABYAAFoASZwAFAAAWwBJmgASAABcAEm') : null;

// Default notification preferences
export const DEFAULT_NOTIFICATION_PREFS = {
  push_enabled: true,
  sound_enabled: true,
  vibration_enabled: true
};
